<template>
  <div style="height: 389px;">
    <!-- <VueEditor style="background-color: #fff;" v-model="content"  :contenteditable="$store.state.operate=='详情'?false:true"  use-custom-image-handler :id="id"  @image-added="editorImageAdded" :editorToolbar="customToolbar"></VueEditor> -->
<!-- 	<span style="top: 90%;" class="el-input__suffix"><span class="el-input__suffix-inner"><span class="el-input__count"><span class="el-input__count-inner">
	            {{content.length}}/1000
	          </span></span></span></span> -->
	<!-- <el-form-item class="w-100" label="">
	 <el-input class="editor-input"  placeholder="源码视图" type='textarea' maxlength='1000' show-word-limit v-model='content'></el-input>
	 </el-form-item> -->
	 <el-upload
	               accept="image/png, image/jpeg, image/jpg, image/jif"
	               class="avatar-uploader"
	               :headers="authHeaders()"
	               :on-success="quillSuccess"
	             :action="$domain+'/api/Upload/PostUpload'" 
	             ></el-upload>
	  <quill-editor class="editor"
	                     ref="myQuillEditor"
	                     v-model="content"
	                     :options="editorOption"
	                     @focus="focus($event)" 
						  placeholder="请填写详情内容描述"
	                    >
	       </quill-editor>
  </div>
</template>
<script>
	import * as imageConversion from 'image-conversion' 
	import Quill from "quill";
	var fonts = ['Microsoft-YaHei','SimSun', 'SimHei','KaiTi','Arial','Times-New-Roman'];
	var Font = Quill.import('formats/font');
	Font.whitelist = fonts; //将字体加入到白名单
	import {encrypt} from '@/js/common';
	 const toolbarOptions =[
                  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
                  ["blockquote", "code-block"], // 引用  代码块
                  [{ header: 1 }, { header: 2 }], // 1、2 级标题
                  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
                  [{ script: "sub" }, { script: "super" }], // 上标/下标
                  [{ indent: "-1" }, { indent: "+1" }], // 缩进
                  // [{'direction': 'rtl'}],                         // 文本方向
                  [{ size:  ['10px', '12px', '14px','16px','18px','20px','24px','26px','32px','48px'] }], // 字体大小
                  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
                  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
                  [{ font: fonts  }], // 字体种类
                  [{ align: [] }], // 对齐方式
                  ["clean"], // 清除文本格式
                  [ "image"] // 链接、图片、视频
                ];
  import {VueEditor} from 'vue2-editor'
  export default {
	   components: { VueEditor },
	            props: {
					  'value':String,
	            },
    data() {
      return {
		  content:'',
       
  
 editorOption: {
        modules: {
          toolbar: {
            container: toolbarOptions, // 工具栏
            handlers: {
              image: function(value) { //编辑器-上传图片
                if (value) {
                                         // 触发input框选择图片文件
                                         document.querySelector(".avatar-uploader input").click();//自定义元素的点击事件
                                     } else {
                                         this.quill.format("image", false);
                                     }
              },
              upload: value => { //编辑器-上传文件
                if (value) {
                  document.querySelector('.uploadFile input').click()
                }
              }
            }
          }
        }
      }

      }
    },
	watch: {
	     content(newval) {
	  this.$emit("input", newval.substring(0,2000));
	     } ,
		 value(newval){
			  this.content=newval;
		 }
	   },
	   mounted() {
		   this.content = this.value||'';
	   },
    methods: { // 失去焦点
	focus(event){
	if(this.$store.state.operate=='详情')  event.enable(false);  //设置富文本编辑器不可编辑
	 },
        authHeaders(){
        	return {
        		Authorization: "Bearer " + localStorage.getItem('TOKEN'),
        		mpv:'1.25',
        		sign:encrypt(new Date().getTime().toString())
        	};
        },
		editorImageAdded(a, b, c, d){
		
			// if (a.type.indexOf('image')>-1&&a.size / 1024 / 1024 > 5) {
				 
			// 	this.$message.error('上传的图片不能超过5MB');
			// 	return;
			// }
			if (a.type.indexOf('image')>-1&&size > 0.5) {
				　imageConversion.compress(a,0.8).then(res=>{
				    　　console.log(res);
					resolve(res)
				  　　})
			}else{
				resolve(a)
			}
			 const data = new FormData();
			    data.append('typeOption', 'upload_image');
			    data.append('upload', a);
				this.$axios.post('/api/Upload/PostUpload',data).then(e=>{
					b.insertEmbed(d, 'image', this.$domain+e.data.path);
				})
		},
		quillSuccess(response) {
		      if(response){
		      // 获取文本编辑器
		      const quill=this.$refs.myQuillEditor.quill
		      // 获取光标位置
		      const pos=quill.getSelection().index
		      // 插入图片到光标位置
		      quill.insertEmbed(pos,'image',this.$domain+ response.data.path)
		      }
		    },
	},
  }
</script>
<style >
	.avatar-uploader{
		display: none;
	}
	.ql-container.ql-snow {
	    border: 1px solid #DCDFE6;
		border-radius: 4px;
	}
	.ql-editor {
		overflow-y: auto;
	}
	.ql-toolbar.ql-snow {
	    border: 1px solid #DCDFE6;
		border-radius: 4px;
	}
	.editor-input textarea{
		width: 100%;
		border-top: 0px;
		height: 100px;
	}
	.editor-input textarea:focus {
	    outline: 0;
	    border-color:#DCDFE6 ;
	}
	
	
	 .editor {
	    line-height: normal !important;
	    height: 300px;
	  }
	  .ql-snow .ql-tooltip[data-mode=link]::before {
	    content: "请输入链接地址:";
	  }
	  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
	      border-right: 0px;
	      content: '保存';
	      padding-right: 0px;
	  }
	 
	  .ql-snow .ql-tooltip[data-mode=video]::before {
	      content: "请输入视频地址:";
	  }
	 
	  .ql-snow .ql-picker.ql-size .ql-picker-label::before,
	  .ql-snow .ql-picker.ql-size .ql-picker-item::before {
	    content: '14px';
	  }
	  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
	  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
	    content: '10px';
	  }
	  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
	  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
	    content: '18px';
	  }
	  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
	  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
	    content: '32px';
	  }
	 
	  .ql-snow .ql-picker.ql-header .ql-picker-label::before,
	  .ql-snow .ql-picker.ql-header .ql-picker-item::before {
	    content: '文本';
	  }
	  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
	  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
	    content: '标题1';
	  }
	  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
	  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
	    content: '标题2';
	  }
	  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
	  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
	    content: '标题3';
	  }
	  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
	  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
	    content: '标题4';
	  }
	  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
	  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
	    content: '标题5';
	  }
	  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
	  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
	    content: '标题6';
	  }
	 
	  .ql-snow .ql-picker.ql-font .ql-picker-label::before,
	  .ql-snow .ql-picker.ql-font .ql-picker-item::before {
	    content: '标准字体';
	  }
	  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
	  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
	    content: '衬线字体';
	  }
	  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
	  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
	    content: '等宽字体';
	  }

</style>